import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import config from '../../../config';
import { translate as t } from '../../../lib/I18n';
import OrderFare from '../../../records/order/Fare';

import ExternalLink from '../../general/ExternalLink';

class FareSummary extends React.PureComponent {

    static propTypes = {
        orderFare: PropTypes.instanceOf(OrderFare).isRequired
    };

    render() {
        const orderFare = this.props.orderFare;

        const ticketTermsUrl = config.get('ticketTermsAndConditions')
            .replace('{ticketTypeCode}', orderFare.ticketType.code);

        return (
            <Row className="fare-summary">
                <Col xs={ 12 } md={ 6 } lg={ 6 } className="text-weight--normal">
                    { orderFare.getName() }&nbsp;
                    <ExternalLink className="text-sm" href={ ticketTermsUrl } message={ t('booking.fares.nre-link.text') }/>&nbsp;
                    { orderFare.isGroupSave() && t('order.summary.groupSave') }
                </Col>
            </Row>
        );
    }
}

export default FareSummary;



// WEBPACK FOOTER //
// ./src/components/roversRangers/checkout/FareSummary.js